var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iframeUrl !== null)?_c('iframe',{staticClass:"w-full h-screen",attrs:{"src":_vm.iframeUrl,"frameborder":"0","allowtransparency":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }